import { HttpClient } from "@angular/common/http";
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';

@Injectable({
  providedIn: 'root'
})
export class DeviceLicenseService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}DeviceLicense`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  generateKey(): Observable<ResponseDefault<string>> {
    return this.http.get<ResponseDefault<string>>(`${this.apiUrl}/generate-key`);
  }

  updateStatus(key: string, status: string): Observable<ResponseDefault<string>> {
    return this.http.put<ResponseDefault<any>>(`${this.apiUrl}/${key}/status`, {
      status
    });
  }
}
